<template>
  <div class="fraction-data-graph">
    <e-chart
      :option="fractionGraphOptions"
      :autoresize="true"
      ref="chart"
      @legendselectchanged="updateContainerCount($event)"
    ></e-chart>
  </div>
</template>

<script>
import stringUtils from '@/components/mixins/stringUtils'

export default {
  name: 'FractionDataGraph',
  props: {
    fractions: {
      type: Array,
      required: true,
    },
  },
  data: function () {
    return {
      containerCount: 0,
    }
  },
  mixins: [stringUtils],
  computed: {
    fractionCostsSeries: function () {
      return this.fractions.map(fractionEntry => {
        return {
          name: fractionEntry.localized_fraction_name,
          value: fractionEntry.total_fraction_costs,
        }
      })
    },
    fractionWeightsSeries: function () {
      return this.fractions.map(fractionEntry => {
        return {
          name: fractionEntry.localized_fraction_name,
          value: fractionEntry.total_fraction_weight_kg,
        }
      })
    },
    fractionGraphOptions: function () {
      return {
        tooltip: {
          trigger: 'item',
          formatter: data => {
            if (data.seriesName === 'fraction_costs') {
              return `${data.marker} ${data.name}: ${this.euro(data.value)}`
            } else if (data.seriesName === 'fraction_weights') {
              return `${data.marker} ${data.name}: ${this.decimal(data.value)} kg`
            }
          },
        },
        title: {
          top: '34%',
          left: 'center',
          text: `${this.containerCount}\n${this.$t('reporting.industry.container')}`,
          textStyle: {
            fontSize: 15,
            fontWeight: 700,
          },
        },
        legend: {
          type: 'scroll',
          left: 'center',
          bottom: 0,
          padding: [10, 20],
          icon: 'circle',
          textStyle: {
            fontWeight: 'lighter',
          },
        },
        series: [
          {
            name: 'fraction_weights',
            type: 'pie',
            radius: ['40%', '55%'],
            center: ['50%', '40%'],
            avoidLabelOverlap: true,
            label: {
              show: true,
              formatter: input => {
                const data = input.data
                return `${this.decimal(data.value)} kg`
              },
              textStyle: {
                fontSize: 14,
                color: '#000',
              },
            },
            labelLine: {
              show: true,
            },
            data: this.fractionWeightsSeries,
          },
          {
            name: 'fraction_costs',
            type: 'pie',
            radius: ['30%', '36%'],
            center: ['50%', '40%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
            },
            labelLine: {
              show: false,
            },
            data: this.fractionCostsSeries,
          },
        ],
      }
    },
  },
  watch: {
    fractions() {
      this.updateContainerCount(null)
    },
  },
  methods: {
    updateContainerCount: function (event) {
      let selectedFractions = this.fractions
      if (event) {
        const selectedFractionNames = event.selected
        selectedFractions = selectedFractions.filter(data => selectedFractionNames[data.localized_fraction_name])
      }

      this.containerCount = selectedFractions.reduce((acc, cur) => acc + cur.container_count, 0)
    },
  },
  mounted() {
    this.updateContainerCount(null)
  },
}
</script>
